import React from 'react';

import { Page } from '@components';
import { Col, Row } from 'antd';
import { Title } from '@styles/components/text';
import { SelectOrdersBody } from './components/select-orders-body';
import { translate } from '@components/i18n';

export const SelectOrders: React.FC = () => {
    return (
        <Page
            title={translate('pages.orderSelection')}
            greyBackground
            withPadding
        >
            <Row>
                <Col span={1} />
                <Col span={22}>
                    <Row>
                        <Title marginTop={20} level={3}>
                            {translate('pages.orderSelection')}
                        </Title>
                    </Row>
                    <SelectOrdersBody />
                </Col>
                <Col span={1} />
            </Row>
        </Page>
    );
};
